import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import s from './NotificationAlert.module.scss';
import bs from '../../../styles/bootstrap-overrides.scss';
import success from '../../../assets/tick-green-filled.svg';
import error from '../../../assets/alert.svg';
import warning from '../../../assets/warning.svg';
import Alert from 'react-bootstrap/Alert';
import info from '../../../assets/info-blue.svg';

const NotificationAlert = ({ status, showBanner, message, closeHandler }) => {
  const iconSrc = status === 'danger' ? error : status === 'warning' ? warning : status === 'success' ? success : info;
  const [show, setShow] = useState(true);
  const [visible, setVisible] = useState(false);
  
  // Replace Transition component with useEffect for animation handling
  useEffect(() => {
    let timeoutId = null;
    
    if (showBanner) {
      // Make component visible immediately
      setVisible(true);
      
      // Auto-hide after timeout if needed
      timeoutId = setTimeout(() => {
        if (!showBanner) {
          setVisible(false);
        }
      }, 5000); // Same timeout as original
    } else {
      // Hide component when showBanner becomes false
      setVisible(false);
    }
    
    // Clean up timeout on unmount or when dependencies change
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [showBanner]);

  const localCloseHandler = () => {
    setShow(false);
    setVisible(false);
    if (closeHandler) {
      closeHandler();
    }
  };

  if (!message || message === '') {
    return <div></div>;
  }
  
  // Only render if both visible and show are true
  if (!visible || !show) {
    return null;
  }

  return (
    <div
      className={classNames(s.notification, {
        [s.enter]: visible,
        [s.error]: status === 'danger',
        [s.warning]: status === 'warning',
        [s.success]: status === 'success'
      })}
    >
      <Alert variant={'plain'} className={s.alert} onClose={() => localCloseHandler()} dismissible>
        {iconSrc && <img src={iconSrc} alt="icon" className={s.icon} />}
        {message}
      </Alert>
    </div>
  );
};

NotificationAlert.propTypes = {
  status: PropTypes.string,
  message: PropTypes.string,
  showBanner: PropTypes.bool.isRequired,
  closeHandler: PropTypes.func
};

export default NotificationAlert;